import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CellPositionDirective} from "./cell-position.directive";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CellPositionDirective
  ],
  exports: [
    CellPositionDirective
  ]
})
export class CellPositionModule {}
